import { buildUrl } from '@packages/shared/src/utils/buildUrl';
import { encodeSelectedFilterValues } from '../queryEncoding';

export const buildSearchUrlWithFilters = (
  query: string,
  activeFilters: { filterId: string; activeValues: { id: string }[] }[],
) => {
  const compressedFilterValues = Object.fromEntries(
    activeFilters.map(({ filterId, activeValues }) => [filterId, activeValues.map(({ id }) => id)]),
  );

  const encodedFilters = encodeSelectedFilterValues(compressedFilterValues);
  const searchParams = new URLSearchParams(encodedFilters.f ? encodedFilters : undefined);

  const pathname = `/s/${encodeURIComponent(query.toLocaleLowerCase().trim()).replace(/%20/g, '+')}/`;

  return buildUrl({ pathname, searchParams });
};
